

import React, { useState, useEffect } from 'react'
import { BoxWrapper } from '../../../style'
import { goBack, getStorage } from '../../../Utils/common';
import arrowIcon from "../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import LoanCalculator from '../../../components/LoanCalculator/LoanCalculator';

function CalculateLoan() {
    const navigate = useNavigate();
    const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);

    useEffect(() => {
        // Check if application is already submitted from storage
        const storedApplicationStatus = getStorage("application_status");
        if (storedApplicationStatus === "submitted") {
            console.log("Application already submitted from storage - setting frozen state");
            setIsApplicationSubmitted(true);
        }
    }, []);

  return (
  
    <BoxWrapper  className="w100 gray" >
        {/* Application Submitted - Frozen State */}
        {isApplicationSubmitted && (
            <div style={{
                backgroundColor: '#f8f9fa',
                border: '2px solid #28a745',
                borderRadius: '10px',
                padding: '30px',
                margin: '20px',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '60px', color: '#28a745', marginBottom: '20px' }}>
                    ✅
                </div>
                <h2 style={{ color: '#28a745', marginBottom: '15px' }}>
                    Application Already Submitted!
                </h2>
                <p style={{ color: '#666', fontSize: '16px', margin: '15px 0' }}>
                    Your application is currently under review. Our teammate will contact you soon.
                </p>
                <p style={{ color: '#888', fontSize: '14px', margin: '10px 0' }}>
                    You cannot calculate loans until your current application status is closed.
                </p>
            </div>
        )}

        {!isApplicationSubmitted && (
        <div className="formmainBox flex">
          <div className="left">
            <div className='center gap4 pointer' onClick={()=>goBack(navigate,"/my-dashboard/eligibility")}>
                <img src={arrowIcon} alt="" /> <span>Back</span>
            </div>
          </div>
          <div className="right">
          <h2>CALCULATING LOANS</h2>

            <LoanCalculator />
          </div>
        </div>
        )}

       </BoxWrapper>
  )
}

export default CalculateLoan;